<script>
  // import {obj} from '../components/container/tabs/mock.js'
  export default {
    name: 'tab-item-render',
    props: {
      node: Object
    },
    data () {
      return {
        formData: {}
      }
    },
    render (h) {
      const {
        viewContent,
        info,
        slots
      } = this.node
      return (
        <tab-item label={info.name} name={info.apiName} count={info.count}>
          {slots?.secondLevel && <template slot="secondLevel">{slots.secondLevel}</template>}
          <render viewContent={viewContent}/>
        </tab-item>
      )
    }
  }
</script>
